<dictionaries-layout [title]="title" [type]="dictionaryType">
  <div class="data-wrapper">
    <fca-data-table
      *ngIf="data"
      [dataDefinition]="dataDefinition"
      [customButtons]="customButtons"
      [data]="data"
      [pageSize]="pageSize"
    ></fca-data-table>
    <div *ngIf="data == null" class="no-data-placeholder">
      Fill form fields to display data
    </div>
  </div>
  <button mat-flat-button class="add-button" (click)="addFuelFee()">
    Add new
  </button>
</dictionaries-layout>
